import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const PushSend = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M13.9688 14.25V18.3885C13.9688 18.6576 13.9157 18.9241 13.8127 19.1728C13.7097 19.4214 13.5587 19.6473 13.3683 19.8376C13.178 20.0279 12.952 20.1788 12.7033 20.2817C12.4547 20.3847 12.1881 20.4376 11.919 20.4375H7.0185C6.74936 20.4376 6.48283 20.3847 6.23415 20.2817C5.98547 20.1788 5.7595 20.0279 5.56915 19.8376C5.37881 19.6473 5.22781 19.4214 5.12479 19.1728C5.02177 18.9241 4.96875 18.6576 4.96875 18.3885V6.73725C4.96875 6.19362 5.18471 5.67226 5.56911 5.28786C5.95351 4.90346 6.47487 4.6875 7.0185 4.6875H10.0312"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.96875 17.0625H13.9688"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.313 4.05291L11.5872 6.93577C11.4754 6.98327 11.3796 7.06176 11.3111 7.16197C11.2425 7.26219 11.204 7.37993 11.2003 7.5013C11.1965 7.62267 11.2275 7.74258 11.2897 7.84687C11.3519 7.95116 11.4426 8.03548 11.5512 8.08985L13.9234 9.27593L15.1094 11.6488C15.1638 11.7572 15.248 11.8478 15.3522 11.91C15.4563 11.9722 15.5761 12.0033 15.6973 11.9997C15.8186 11.9962 15.9363 11.958 16.0366 11.8898C16.1369 11.8216 16.2156 11.7262 16.2635 11.6148L19.1517 4.88896C19.2023 4.77172 19.2165 4.64198 19.1924 4.51658C19.1683 4.39118 19.107 4.27592 19.0166 4.18577C18.9262 4.09562 18.8107 4.03475 18.6852 4.01106C18.5598 3.98736 18.4301 4.00195 18.313 4.05291V4.05291Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
